import { InjectionToken } from '@angular/core';

import { RecommendationItem } from '@core/services/api/recommendations/recommendations-api.service';

/** Runtime VM emitted by `CartRecommendationCardsBlock` data sources. */
export type CartRecommendationCardsBlockViewModel = {
  recommendations: RecommendationItem[];
};

export const CART_RECOMMENDATION_CARDS_BLOCK_EMPTY_VM: CartRecommendationCardsBlockViewModel = {
  recommendations: [],
};

export interface CartRecommendationCardsBlockDataSource {
  readonly vm$: import('rxjs').Observable<CartRecommendationCardsBlockViewModel>;
}

export const CART_RECOMMENDATION_CARDS_BLOCK_DATA_SOURCE =
  new InjectionToken<CartRecommendationCardsBlockDataSource>(
    'CART_RECOMMENDATION_CARDS_BLOCK_DATA_SOURCE',
  );
